import OverflowMenuItem from '@/components/_common/OverflowMenu/OverflowMenuItem';
import { PolarisIcon } from '@/exports/columnCommonComponents';
import { FileManagerInventoryFile } from '@/redux/slices/slice_types';

interface FileDownloadProps {
  file: FileManagerInventoryFile;
  handleDownload: (file: FileManagerInventoryFile) => void;
}

const FileDownload = ({ file, handleDownload }: FileDownloadProps) => {
  const handleOnClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    handleDownload(file);
  };

  return (
    <OverflowMenuItem onClick={handleOnClick}>
      <PolarisIcon icon="download" height={21} style={{ marginLeft: 2 }} />
      <span>Download</span>
    </OverflowMenuItem>
  );
};

export default FileDownload;
